module.exports = __webpack_public_path__ + "img/page1.d4307bc3.png";